import React from 'react';
import { Redirect, Route} from 'react-router-dom';
import { AuthContext } from "../App";

function verificarPath(authState, pProps) {
    const pPath = pProps.match.path;
    let found = false;

    if (pPath === "/") {
        found = true;
    } else {
        for (let i = 0; i < authState.features.length; i++) {
            if (authState.features[i] === pPath) {
                found = true;
                break;
            }
        }
    }
    return found;
}

function ProtectedRoute({component: Component, ...restOfProps}) {
    const { state: authState } = React.useContext(AuthContext);
    return (
        <Route {...restOfProps}
        render={
            (props)=> 
                verificarPath(authState, props) ? <Component {...props} /> : <Redirect to="/" />
        }
        />
    );

}

export default ProtectedRoute;